import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface CalloutProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
}

const Callout = forwardRef<HTMLDivElement, CalloutProps>(
  ({ className, icon, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex w-full items-start gap-2 rounded-md border border-[rgba(0,0,51,0.06)] bg-[rgba(0,0,85,0.01)] p-3",
          className
        )}
        {...props}
      >
        {icon && (
          <div className="flex h-5 items-center">
            {icon}
          </div>
        )}
        <p className="flex-1 text-sm leading-5 text-[rgba(0,0,0,0.7)]">
          {children}
        </p>
      </div>
    );
  }
);

Callout.displayName = "Callout";

export { Callout };

